import React from 'react';
import { Button, Typography } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';

interface WithdrawalHeaderProps {
  loading: boolean;
  onRefresh: () => void;
}

const { Title, Text } = Typography;

const WithdrawalHeader: React.FC<WithdrawalHeaderProps> = ({
  loading,
  onRefresh,
}) => {
  return (
    <div className="flex justify-between items-center mb-4">
      <div>
        <Title level={2} className="mb-2">
          Kiểm tra tiền POS - Dịch vụ đáo hạn
        </Title>
        <Text type="secondary">
          Quản lý và kiểm tra các giao dịch rút tiền từ máy POS cho dịch vụ đáo
          hạn
        </Text>
      </div>
      <Button
        icon={<ReloadOutlined />}
        onClick={onRefresh}
        loading={loading}
        type="primary"
      >
        Tải lại
      </Button>
    </div>
  );
};

export default WithdrawalHeader;
